import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../../shared/config/storeConfig/StoreSchema'
import { showToast } from '../../../../shared/lib/showToast/showToast'
import { appHandleError } from '../../../../shared/lib/appHandleError/appHandleError'
import { fetchApps } from '../../../../pages/AppsPage'
import { modalActions, ModalTypes } from '../../../../entities/Modal'

export const deleteApp = createAsyncThunk<
	void,
	string,
	ThunkConfig<string>
>(
	'deleteApplication',
	async (appId, thunkAPI) => {

		const { dispatch, extra: { api }, rejectWithValue } = thunkAPI

		try {
			await api.delete(`/applications/${appId}`)

			showToast({
				type: 'success',
				toastId: 'deleteApplication',
				message: 'Success'
			})

			dispatch(fetchApps())
		} catch (e: any) {
			console.log(e)
			if (e?.response.status === 409) {
				dispatch(modalActions.showModal({
					modalType: ModalTypes.SHOW_409_MODAL,
					data: e?.response.data.message
				}))
			} else {
				appHandleError(e, 'deleteApplication', 'Failed to delete application')
			}
			return rejectWithValue('Error occurred on application delete')
		}
	})